import React from 'react'
import { useParams } from 'react-router-dom'
import DriverDetailContainerNew from "./DriverDetailContainerNew"

const DriverDetailContainerWrapper = (props) => {
    const params = useParams()
    return <DriverDetailContainerNew {...props} params={params} />
}

export default DriverDetailContainerWrapper
